// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#tickerTape[data-v-65a21525]{z-index:1031;position:fixed;width:100%;left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
